import { LabeledContainer, CollapsibleContent, Checkbox, Input } from '@schibsted-svp/react-ui';
import { Control, Controller, UseFormRegister } from 'react-hook-form';
import type { Asset } from '@schibsted-svp/svp-api-types';
import { getNewsroomConfig } from 'config';
import type { FormValues } from '../types';

import css from './StoriesProperties.module.scss';

type StoriesPropertiesProps = {
    control: Control<FormValues>;
    register: UseFormRegister<FormValues>;
    asset: Asset;
};

export function StoriesProperties({ control, register, asset }: StoriesPropertiesProps) {
    const { features } = getNewsroomConfig(asset.provider);

    if (!features.storiesProperties?.enabled) {
        return null;
    }

    return (
        <CollapsibleContent label="Stories properties">
            <section className={css.content}>
                <Controller
                    name="additional.metadata.disableReactions"
                    control={control}
                    render={({ field: { value, ...rest } }) => (
                        <Checkbox
                            {...rest}
                            checked={!value}
                            onChange={(event) => rest.onChange(!event.currentTarget.checked)}
                            label="Reactions"
                        />
                    )}
                />
                <Controller
                    name="additional.metadata.enableComments"
                    control={control}
                    render={({ field: { value, ...rest } }) => (
                        <Checkbox {...rest} checked={Boolean(value)} label="Comments" />
                    )}
                />
                <Controller
                    name="additional.metadata.lockCommenting"
                    control={control}
                    render={({ field: { value, ...rest } }) => (
                        <Checkbox {...rest} checked={Boolean(value)} label="Lock comment section" />
                    )}
                />
                <LabeledContainer strict label="Horizontal variant asset id">
                    <Input {...register('additional.metadata.horizontalAssetId')} />
                </LabeledContainer>
                <Controller
                    name="additional.metadata.enableBigScreenButton"
                    control={control}
                    render={({ field: { value, ...rest } }) => (
                        <Checkbox {...rest} checked={Boolean(value)} label="How to watch on VGTV button" />
                    )}
                />
            </section>
        </CollapsibleContent>
    );
}
